export default __webpack_public_path__ + "media/banner.572adf66.png";